// 대출거래정보 페이지 전용 JavaScript

// 더미 데이터 생성 함수
function generateDummyTransactions(accountNumber) {
  // 계좌번호별 더미 데이터
  const dummyData = {
    '1001-2345-6789': {
      accountNumber: '1001-2345-6789',
      productName: '주식담보대출 A형',
      stockAccount: '8012-3456-7890',
      brokerName: 'DB증권',
      startDate: '2024-01-15',
      endDate: '2025-12-31',
      loanAmount: '300,000,000원',
      balance: '225,000,000원',
      schedules: [
        { sequence: 1, date: '2024.02.15', periodStart: '2024.01.16', periodEnd: '2024.02.15', amount: '27,500,000', interest: '2,500,000', balance: '275,000,000' },
        { sequence: 2, date: '2024.03.15', periodStart: '2024.02.16', periodEnd: '2024.03.15', amount: '27,291,667', interest: '2,291,667', balance: '250,000,000' },
        { sequence: 3, date: '2024.04.15', periodStart: '2024.03.16', periodEnd: '2024.04.15', amount: '27,083,333', interest: '2,083,333', balance: '225,000,000' },
        { sequence: 4, date: '2024.05.15', periodStart: '2024.04.16', periodEnd: '2024.05.15', amount: '26,875,000', interest: '1,875,000', balance: '200,000,000' },
        { sequence: 5, date: '2024.06.15', periodStart: '2024.05.16', periodEnd: '2024.06.15', amount: '26,666,667', interest: '1,666,667', balance: '175,000,000' },
        { sequence: 6, date: '2024.07.15', periodStart: '2024.06.16', periodEnd: '2024.07.15', amount: '26,458,333', interest: '1,458,333', balance: '150,000,000' },
        { sequence: 7, date: '2024.08.15', periodStart: '2024.07.16', periodEnd: '2024.08.15', amount: '26,250,000', interest: '1,250,000', balance: '125,000,000' },
        { sequence: 8, date: '2024.09.15', periodStart: '2024.08.16', periodEnd: '2024.09.15', amount: '26,041,667', interest: '1,041,667', balance: '100,000,000' },
        { sequence: 9, date: '2024.10.15', periodStart: '2024.09.16', periodEnd: '2024.10.15', amount: '25,833,333', interest: '833,333', balance: '75,000,000' },
        { sequence: 10, date: '2024.11.15', periodStart: '2024.10.16', periodEnd: '2024.11.15', amount: '25,625,000', interest: '625,000', balance: '50,000,000' },
        { sequence: 11, date: '2024.12.15', periodStart: '2024.11.16', periodEnd: '2024.12.15', amount: '25,416,667', interest: '416,667', balance: '25,000,000' },
        { sequence: 12, date: '2025.01.15', periodStart: '2024.12.16', periodEnd: '2025.01.15', amount: '25,208,333', interest: '208,333', balance: '0' }
      ]
    },
    '1001-2345-6790': {
      accountNumber: '1001-2345-6790',
      productName: '주식담보대출 B형',
      stockAccount: '8012-3456-7891',
      brokerName: 'DB증권',
      startDate: '2024-06-01',
      endDate: '2025-06-30',
      loanAmount: '300,000,000원',
      balance: '175,000,000원',
      schedules: [
        { sequence: 1, date: '2024.07.01', periodStart: '2024.06.02', periodEnd: '2024.07.01', amount: '27,500,000', interest: '2,500,000', balance: '275,000,000' },
        { sequence: 2, date: '2024.08.01', periodStart: '2024.07.02', periodEnd: '2024.08.01', amount: '27,291,667', interest: '2,291,667', balance: '250,000,000' },
        { sequence: 3, date: '2024.09.01', periodStart: '2024.08.02', periodEnd: '2024.09.01', amount: '27,083,333', interest: '2,083,333', balance: '225,000,000' },
        { sequence: 4, date: '2024.10.01', periodStart: '2024.09.02', periodEnd: '2024.10.01', amount: '26,875,000', interest: '1,875,000', balance: '200,000,000' },
        { sequence: 5, date: '2024.11.01', periodStart: '2024.10.02', periodEnd: '2024.11.01', amount: '26,666,667', interest: '1,666,667', balance: '175,000,000' },
        { sequence: 6, date: '2024.12.01', periodStart: '2024.11.02', periodEnd: '2024.12.01', amount: '26,458,333', interest: '1,458,333', balance: '150,000,000' },
        { sequence: 7, date: '2025.01.01', periodStart: '2024.12.02', periodEnd: '2025.01.01', amount: '26,250,000', interest: '1,250,000', balance: '125,000,000' },
        { sequence: 8, date: '2025.02.01', periodStart: '2025.01.02', periodEnd: '2025.02.01', amount: '26,041,667', interest: '1,041,667', balance: '100,000,000' },
        { sequence: 9, date: '2025.03.01', periodStart: '2025.02.02', periodEnd: '2025.03.01', amount: '25,833,333', interest: '833,333', balance: '75,000,000' },
        { sequence: 10, date: '2025.04.01', periodStart: '2025.03.02', periodEnd: '2025.04.01', amount: '25,625,000', interest: '625,000', balance: '50,000,000' },
        { sequence: 11, date: '2025.05.01', periodStart: '2025.04.02', periodEnd: '2025.05.01', amount: '25,416,667', interest: '416,667', balance: '25,000,000' },
        { sequence: 12, date: '2025.06.01', periodStart: '2025.05.02', periodEnd: '2025.06.01', amount: '25,208,333', interest: '208,333', balance: '0' }
      ]
    },
    '1001-2345-6791': {
      accountNumber: '1001-2345-6791',
      productName: '주식담보대출 C형',
      stockAccount: '8012-3456-7892',
      brokerName: 'DB증권',
      startDate: '2024-09-15',
      endDate: '2025-09-15',
      loanAmount: '300,000,000원',
      balance: '300,000,000원',
      schedules: [
        { sequence: 1, date: '2024.10.15', periodStart: '2024.09.16', periodEnd: '2024.10.15', amount: '27,500,000', interest: '2,500,000', balance: '275,000,000' },
        { sequence: 2, date: '2024.11.15', periodStart: '2024.10.16', periodEnd: '2024.11.15', amount: '27,291,667', interest: '2,291,667', balance: '250,000,000' },
        { sequence: 3, date: '2024.12.15', periodStart: '2024.11.16', periodEnd: '2024.12.15', amount: '27,083,333', interest: '2,083,333', balance: '225,000,000' },
        { sequence: 4, date: '2025.01.15', periodStart: '2024.12.16', periodEnd: '2025.01.15', amount: '26,875,000', interest: '1,875,000', balance: '200,000,000' },
        { sequence: 5, date: '2025.02.15', periodStart: '2025.01.16', periodEnd: '2025.02.15', amount: '26,666,667', interest: '1,666,667', balance: '175,000,000' },
        { sequence: 6, date: '2025.03.15', periodStart: '2025.02.16', periodEnd: '2025.03.15', amount: '26,458,333', interest: '1,458,333', balance: '150,000,000' },
        { sequence: 7, date: '2025.04.15', periodStart: '2025.03.16', periodEnd: '2025.04.15', amount: '26,250,000', interest: '1,250,000', balance: '125,000,000' },
        { sequence: 8, date: '2025.05.15', periodStart: '2025.04.16', periodEnd: '2025.05.15', amount: '26,041,667', interest: '1,041,667', balance: '100,000,000' },
        { sequence: 9, date: '2025.06.15', periodStart: '2025.05.16', periodEnd: '2025.06.15', amount: '25,833,333', interest: '833,333', balance: '75,000,000' },
        { sequence: 10, date: '2025.07.15', periodStart: '2025.06.16', periodEnd: '2025.07.15', amount: '25,625,000', interest: '625,000', balance: '50,000,000' },
        { sequence: 11, date: '2025.08.15', periodStart: '2025.07.16', periodEnd: '2025.08.15', amount: '25,416,667', interest: '416,667', balance: '25,000,000' },
        { sequence: 12, date: '2025.09.15', periodStart: '2025.08.16', periodEnd: '2025.09.15', amount: '25,208,333', interest: '208,333', balance: '0' }
      ]
    }
  };

  return dummyData[accountNumber] || null;
}

// 금액 포맷팅 함수
function formatAmount(amount) {
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';
}

// 모달 열기
function openDetailModal(accountNumber) {
  const modal = document.getElementById('detailModal');
  const data = generateDummyTransactions(accountNumber);
  
  if (!data) {
    alert('해당 계좌의 상세 정보를 찾을 수 없습니다.');
    return;
  }

  // 기본 정보 표시
  document.getElementById('modalAccountNumber').textContent = data.accountNumber;
  document.getElementById('modalProductName').textContent = data.productName;
  document.getElementById('modalStockAccount').textContent = data.stockAccount;
  document.getElementById('modalBrokerName').textContent = data.brokerName;
  document.getElementById('modalStartDate').textContent = data.startDate;
  document.getElementById('modalEndDate').textContent = data.endDate;
  document.getElementById('modalLoanAmount').textContent = data.loanAmount;
  document.getElementById('modalBalance').textContent = data.balance;

  // 거래내역 리스트 생성 (1줄씩 리스트 형식)
  const listBody = document.getElementById('scheduleListBody');
  listBody.innerHTML = ''; // 기존 내용 제거

  if (data.schedules && data.schedules.length > 0) {
    data.schedules.forEach(schedule => {
      const itemDiv = document.createElement('div');
      itemDiv.className = 'schedule-list-item';
      
      itemDiv.innerHTML = `
        <div class="schedule-col-seq">${schedule.sequence}</div>
        <div class="schedule-col-period">${schedule.periodStart} ~ ${schedule.periodEnd}</div>
        <div class="schedule-col-interest">${formatAmount(schedule.interest)}</div>
        <div class="schedule-col-amount">${formatAmount(schedule.amount)}</div>
        <div class="schedule-col-balance">${formatAmount(schedule.balance)}</div>
        <div class="schedule-col-date">${schedule.date}</div>
      `;
      listBody.appendChild(itemDiv);
    });
  } else {
    listBody.innerHTML = '<div style="text-align: center; padding: 2rem; color: #666;">거래내역이 없습니다.</div>';
  }

  // 모달 표시
  modal.style.display = 'block';
  
  // body 스크롤 방지
  document.body.style.overflow = 'hidden';
}

// 모달 닫기
function closeDetailModal() {
  const modal = document.getElementById('detailModal');
  modal.style.display = 'none';
  
  // body 스크롤 복원
  document.body.style.overflow = 'auto';
}

// 모달 외부 클릭시 닫기
window.onclick = function(event) {
  const modal = document.getElementById('detailModal');
  if (event.target === modal) {
    closeDetailModal();
  }
};

// ESC 키로 모달 닫기
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const modal = document.getElementById('detailModal');
    if (modal.style.display === 'block') {
      closeDetailModal();
    }
  }
});

// 계좌번호 클릭시에도 모달 열기
document.addEventListener('DOMContentLoaded', function() {
  const accountNumbers = document.querySelectorAll('.account-number');
  accountNumbers.forEach(function(element) {
    element.addEventListener('click', function() {
      const accountNumber = this.getAttribute('data-account');
      openDetailModal(accountNumber);
    });
  });
});

// 전역 함수 노출 (Vue에서 사용 가능)
window.generateDummyTransactions = generateDummyTransactions;
window.formatAmount = formatAmount;
window.openDetailModal = openDetailModal;
window.closeDetailModal = closeDetailModal;
